<div class="table-responsive">
    <table class="table table-striped table-hover">
        <thead>
        <tr>
            <th style="width: 40%;">Nom</th>
            <th style="width: 40%;">Capacité</th>
            <th style="width: 20%;">Id Google Calendar</th>
            <th style="width: 150px;min-width: 150px;max-width: 150px;"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let room of location.rooms?location.rooms.sort(roomSort):[]">
            <td>
                <span *ngIf="!room['editing']" (click)="swapEditing(room)">{{room.name}}</span>
                <input *ngIf="room['editing']" [(ngModel)]="room.name"/>
            </td>
            <td>
                <span *ngIf="!room['editing']" (click)="swapEditing(room)">{{room.capacity}}</span>
                <input *ngIf="room['editing']" [(ngModel)]="room.capacity"/>
            </td>
            <td>
                <span *ngIf="!room['editing']" (click)="swapEditing(room)">{{room.googleCalendarId}}&nbsp;</span>
                <input *ngIf="room['editing']" [(ngModel)]="room.googleCalendarId"/>
            </td>
            <td *ngIf="room['editing']" style="text-align: right;padding: 5px 5px 0;">
                <button class="btn btn-sm btn-default" style="margin-bottom: 4px;" (click)="save(room)">
                    <i class="fa fa-fw fa-check"></i></button>
                <button class="btn btn-sm btn-default" style="margin-bottom: 4px;" (click)="cancelEditing(room)"><i
                        class="fa fa-fw fa-ban"></i></button>
                <button class="btn btn-sm btn-default" style="margin-bottom: 4px;" (click)="remove(room)"><i
                        class="fa fa-fw fa-trash"></i></button>
            </td>
            <td>
            </td>
        </tr>
        <tr *ngIf="addingRoom">
            <td>
                <input [(ngModel)]="addingRoom.name"/>
            </td>
            <td>
                <input [(ngModel)]="addingRoom.capacity"/>
            </td>
            <td>
                <input [(ngModel)]="addingRoom.googleCalendarId"/>
            </td>
            <td style="text-align: right;padding: 5px 5px 0;">
                <button class="btn btn-sm btn-default" style="margin-bottom: 4px;" (click)="create()">
                    <i class="fa fa-fw fa-check"></i></button>
                <button class="btn btn-sm btn-default" style="margin-bottom: 4px;" (click)="addingRoom = null"><i
                        class="fa fa-fw fa-ban"></i></button>
            </td>
        </tr>
        </tbody>
    </table>
</div>
<button class="btn btn-primary btn-round" style="border-radius: 50%;width: 40px;height: 40px;"
        (click)="displayCreate()">+
</button>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/location/room/room.component.html